export enum DeliveryTypeEnum {
  Courier = 'courier',
  // CourierCoD = 'courierCoD',
  OnArteTransport = 'onArteTransport',
  SelfPickup = 'selfPickup'
  // todo przedyskutować opcje "dostawy" przedmiotów niematerialnych / cyfrowych
}
